"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var StyledGrid = (0, _styledComponents["default"])(_Grid["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n"])), function (_ref) {
  var spacing = _ref.spacing,
      container = _ref.container;
  return container && spacing > 0 && "\n     {\n      margin-left: 0px;\n      margin-right: 0px;\n      transform: translateX(-".concat(spacing * 2, "px);\n    }\n  ");
});

var MaterialGrid = function MaterialGrid(props) {
  var container = props.container,
      spacing = props.spacing;

  if (container && spacing > 0) {
    return /*#__PURE__*/_react["default"].createElement(StyledGrid, props);
  }

  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], props);
};

MaterialGrid.propTypes = {
  container: _propTypes["default"].bool,
  spacing: _propTypes["default"].number
};
var _default = MaterialGrid;
exports["default"] = _default;